import React, { useRef, useState } from 'react';
import { Translate } from '../../../../config/TranslationProvider';
import classNames from 'classnames';
import LocationsFilter from '../../../filter/LocationsFilter';
import LocationsListing from '../../../sections/LocationsListing';
import MultipleMapLocations from '../../../map/MapMultipleLocations';
import { useAppConfiguration } from '../../../../AppConfiguration';
import ListingActionButton from '../../../partials/ListingActionButton';
import useScrollObserver from '../../../../util/useScrollObserver';

const LocationsListingMain = ({
    locationGroups,
    fetchMore,
    canFetchMore,
    isFetchingMore,
    tags,
    onSubmit,
    listType,
    setListType,
    filter,
    fixedFilter
}) => {
    const {listingTitle: {locations: listingTitle}} = useAppConfiguration();
    const [showFilter, setShowFilter] = useState(false);

    const filterForm = (
        <LocationsFilter
            tags={tags}
            onSubmit={onSubmit}
            filter={filter}
            fixedFilter={fixedFilter}
        />
    );

    const locationsFound = locationGroups[0].data.length > 0;

    const toolbarRef = useRef();
    const handleScroll = () => {
        if (!toolbarRef.current) {
            return;
        }

        if (window.scrollY >= 425) {
            toolbarRef.current.style.visibility = 'visible';
        } else {
            toolbarRef.current.style.visibility = 'hidden';
        }
    };

    useScrollObserver(handleScroll);

    return (
        <div className="row">
            {/* Locations Filter */}
            <div className="col-lg-4 mt-lg-0">
                <div className="filter-dropdown">
                    <div className={classNames({
                        dropdown: true,
                        show: showFilter,
                    })}>
                        <button
                            id="filterDropdown"
                            type="button"
                            className="btn btn-primary dropdown-toggle"
                            aria-haspopup="true"
                            aria-expanded={showFilter}
                            aria-label="Filter öffnen / schließen"
                            onClick={e => {
                                e.target.blur();

                                setShowFilter(showFilter => !showFilter);
                            }}
                        >
                            Filter
                        </button>
                        <div aria-labelledby="filterDropdown" className={classNames({
                            'dropdown-menu': true,
                            show: showFilter,
                        })}>
                            {filterForm}
                        </div>
                    </div>
                </div>
                <div className="filter-wrapper">
                    <div className="events-filter">
                        {filterForm}
                    </div>
                    <div
                        ref={toolbarRef}
                        className="atbd_listing_action_btn default-ad-search btn-toolbar substitute-btn-toolbar"
                        role="toolbar"
                    >
                        <ListingActionButton btnType="list" listType={listType} setListType={setListType} />
                        <ListingActionButton btnType="grid" listType={listType} setListType={setListType} />
                        <ListingActionButton btnType="map" listType={listType} setListType={setListType} />
                    </div>
                </div>
            </div>

            {/* Events Listing */}
            <div className="col-lg-8 mt-lg-0">
                {!locationsFound && (
                    <div className="section-title">
                        <h2><Translate value="no_location_results" listingTitle={listingTitle} /></h2>
                    </div>
                )}

                {locationsFound && listType === 'map' && (
                    <MultipleMapLocations
                        initialLocations={locationGroups[0]}
                        filter={filter} />
                )}
                {locationsFound && listType !== 'map' && (
                    <LocationsListing
                        type={listType === 'grid' ? 'grid6' : 'grid12'}
                        locationGroups={locationGroups}
                        fetchMore={fetchMore}
                        canFetchMore={canFetchMore}
                        isFetchingMore={isFetchingMore}
                    />
                )}
            </div>
        </div>
    );
};

export default LocationsListingMain;
